import { mapMarkerPin, /* mapMarkerSavedBoard */ } from './icons'
import { MarkersGroup } from 'utils/MarksGroup'
import { useNavigate } from 'react-router-dom'
import { Marker, Popup } from 'react-leaflet'
import { openMap } from 'utils/openMap'
import React from 'react'

interface MarkersProps {
  data: places.PlacesResponse | null
}

interface DateParts {
  day: string
  monthName: string
  year: string
}

const Markers: React.FC<MarkersProps> = ({ data})  => {
  const navigate = useNavigate()

  const renderMarkers: (_: places.PlacesSavedBoard) => JSX.Element | null = ({ id, name, biography, birth, death, gps, img
   }) => {
    const parseDate = (dateString: string): DateParts => {

      const months = [
        'stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
        'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'
      ]

      const [year, month, day] = dateString.split('-')
      const monthName = months[parseInt(month, 10) - 1]

      return {
        day,
        monthName,
        year
      }
    }

    const birthParts = birth ? parseDate(birth) : { day: '', monthName: '', year: '' }
    const deathParts = death ? parseDate(death) : { day: '', monthName: '', year: '' }

    if (!gps) return null
    return <Marker
      key={id}
      icon={mapMarkerPin}
      position={[Number(gps.latitude), Number(gps.longitude)]}>
      <Popup maxWidth={300}>
        <div className='marker__popup'>
          {img && <div className='img'>
             <img
              key={id}
              src={img}
              alt={name}
            />
          </div>}
          <h3>{name}</h3>
          <div className="date">
            <div className="top">
              <span></span><hr /><span></span>
            </div>
            <div>
              <span>{birthParts.day} </span>
              <span>{birthParts.monthName} </span>
              <span>{birthParts.year}</span>
            </div>
            <div>
              <span>{deathParts.day} </span>
              <span>{deathParts.monthName} </span>
              <span>{deathParts.year}</span>
            </div>
          </div>
          <div className="buttons">
            <button
              className='btn btn--pin'
              onClick={() => {
                openMap(gps.latitude, gps.longitude)
              }}>
              <i className="icon icon--navigate"></i>
              Nawiguj
            </button>
            <button className='btn btn--pin' onClick={() => navigate(`/${biography ? 'profile' : 'profilepin'}/${id}`)}>Profil</button>
          </div>

        </div>
      </Popup>
    </Marker>
  }

  if (data) {
    return (
      <MarkersGroup>
        {data.myBoards?.map(renderMarkers)}
        {data.savedBoards?.map(renderMarkers)}
      </MarkersGroup>
    )
  }
  return null
}

export default Markers